import icons from "../views/icons";
import {
  LiveHelpOutlined,
  AdminPanelSettingsOutlined,
  ManageAccountsOutlined,
  ViewModuleOutlined,
} from "@mui/icons-material";

/** Maps icon_key from API catalog to sidebar assets or MUI icons. */
export const MODULE_ICON_MAP = {
  news: { icon: icons.news, alt: "news" },
  knowledge: { icon: icons.knowledge, alt: "knowledge" },
  privilege: { icon: icons.privilege, alt: "privilege" },
  onboarding: { icon: icons.onboarding, alt: "onboarding" },
  emergency: { icon: icons.emergency, alt: "emergency" },
  claimForm: { icon: icons.claimForm, alt: "claim form" },
  user: { icon: icons.user, alt: "user" },
  inquiry: { icon: icons.inquirys, alt: "inquiry" },
  liveHelp: { muiIcon: LiveHelpOutlined, alt: "help" },
  manageAccounts: { muiIcon: ManageAccountsOutlined, alt: "manage accounts" },
  adminPanel: { muiIcon: AdminPanelSettingsOutlined, alt: "admin panel" },
  viewModule: { muiIcon: ViewModuleOutlined, alt: "module" },
};

export const ICON_KEY_OPTIONS = Object.keys(MODULE_ICON_MAP);

export const resolveModuleIcon = (iconKey) => {
  if (iconKey && MODULE_ICON_MAP[iconKey]) {
    return MODULE_ICON_MAP[iconKey];
  }
  return { muiIcon: ViewModuleOutlined, alt: "module" };
};
